import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { UpdateStreamInput } from '@/__generated__/graphql.ts';
import { gql } from '@/__generated__/index.ts';

const UPDATE_STREAM = gql(`
  mutation UpdateStream($id: ID!, $input: UpdateStreamInput!) {
    updateStream(id: $id, input: $input) {
      id
      name
      description
      descriptionJson
      label
      packageOnly
      apiAccessEnabled
      streamCategory
      customTargetsData {
        maxTargets
        maxTotalTargets
        minTargets
        stepSize
        targetType
        targetTypeInstruction
      }
    }
  }
`);

export const useUpdateStream = (id: string) => {
  const toast = useToast();

  const [updateStreamMutation, result] = useMutation(UPDATE_STREAM, {
    onError: (error) => {
      toast.error({
        title: 'Failed to update stream',
        subTitle: error.message,
      });
    },
    onCompleted: () => {
      toast.info({
        title: 'Stream successfully updated',
      });
    },
  });

  const updateStream = (input: UpdateStreamInput) => {
    return updateStreamMutation({
      variables: {
        id,
        input,
      },
    });
  };

  return [updateStream, result] as const;
};
